<template>
  <div class="phone-menu">
    <cover v-model="showPhoneMenu" @click.stop.native="togglePhoneMenu()" />
    <transition name="slide-fade">
      <div class="menu-container" v-show="showPhoneMenu">
        <div class="tab" @click.stop="togglePhoneMenu()">
          <svg-icon :name="closeTab.iconName"></svg-icon>
          <span>{{ closeTab.label }}</span>
        </div>
        <div class="tab" v-for="(tab, index) in tabs" :key="index"
          :class="{ 'selected' : tab.label === currentTab.label }"
          @click.stop="switchTab(tab)">
          <svg-icon v-if="tab.label === currentTab.label"
            :name="`${tab.iconName}-active`"></svg-icon>
          <svg-icon v-else :name="`${tab.iconName}-inactive`"></svg-icon>
          <span>{{ tab.label }}</span>
        </div>
        <div class="tab">
          <avatar class="notranslate" :avatar-name="username" :width="20" :height="20"
          :font-size="8"></avatar>
          <span class="notranslate">{{ username }}</span>
        </div>
        <a class="tab" href="/lendingcircles/secur/logout.jsp">
          <svg-icon :name="signOutTab.iconName"></svg-icon>
          <span>{{ signOutTab.label }}</span>
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PhoneMenu',
  data() {
    return {
      closeTab: {
        label: 'Close',
        iconName: 'close'
      },
      signOutTab: {
        label: 'Sign Out',
        iconName: 'sign-out'
      }
    };
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab,
      userInfo: state => state.userInfo
    }),
    tabs() {
      return window.siderBarTabs;
    },
    showPhoneMenu: {
      get() {
        return this.$store.state.showPhoneMenu;
      },
      set(value) {
        this.$store.commit('SHOW_PHONE_MENU_CHANGED', value)
      }
    },
    username() {
      return `${this.userInfo.firstName} ${this.userInfo.lastName}`;
    }
  },
  methods: {
    switchTab(tab) {
      if (this.currentTab.label !== tab.label) {
        this.$store.commit('CURRENT_TAB_CHANGED', tab);
        this.$router.push({name: tab.label})
      }
      this.togglePhoneMenu();
      this.$nextTick(() => {
        document.getElementById('mainPage').scrollIntoView();
      })
    },
    togglePhoneMenu() {
      this.$store.commit('SHOW_PHONE_MENU_CHANGED', false);
    },
  }
}
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 300ms cubic-bezier(1.0, 0.5, 0.8, 1.0);;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.phone-menu {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .menu-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 999999;
    width: $sidebar-width;
    height: 100%;
    @include inline-flex-col;
    background-color: $bg-color-white;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    color: $tab-active;
    transition: all 300ms cubic-bezier(0, 0, 0.58, 1);

    .tab {
      margin: 5px 0;
      padding-left: 15px;
      padding-right: 15px;
      height: 50px;
      @include inline-flex-row;
      align-items: center;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      transition: all 200ms linear;

      .icon, .avatar {
        margin-right: 10px;
      }

      span {
        flex: 1;
      }

      &:hover {
        cursor: pointer;
      }
    }

    a {
      color: #2eb8c0;
    }

    .selected {
      color: $font-color-white;
      background-color: $tab-active;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/PhoneMenu.vue